import React from 'react';
import { createPortal } from 'react-dom';
import { RefreshCw } from 'lucide-react';
import styles from './SyncLoadingOverlay.module.scss';

interface SyncLoadingOverlayProps {
  isOpen: boolean;
  title?: string;
  message?: string;
}

export const SyncLoadingOverlay: React.FC<SyncLoadingOverlayProps> = ({
  isOpen,
  title = 'Syncing Data...',
  message = 'Please wait while we synchronize system data. Do not navigate away or close the browser window.',
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className={styles.backdrop} data-testid="sync-loader-overlay" role="dialog" aria-modal="true">
      <div className={styles.modal}>
        <div className={styles.spinnerContainer}>
          <div className={styles.spinnerOuter} />
          <div className={styles.iconWrapper}>
            <RefreshCw size={28} />
          </div>
        </div>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.subtitle}>{message}</p>
        <div className={styles.statusBadge}>
          <span className={styles.dot} />
          <span>Synchronizing in progress</span>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default SyncLoadingOverlay;
